import React from "react";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      skills: [
        {
          id: "flutter",
          content: "Flutter",
          percentage: "80%",
          value: "80"
        },
        {
          id: "ionic",
          content: "Ionic",
          percentage: "70%",
          value: "70"
        },
        {
          id: "react",
          content: "React",
          percentage: "50%",
          value: "50"
        },
        {
          id: "angular",
          content: "Angular",
          percentage: "75%",
          value: "75"
        },
        {
          id: "codeigniter-laravel",
          content: "Codeigniter & Laravel",
          percentage: "75%",
          value: "75"
        },
        {
          id: "javascript",
          content: "Javascript",
          percentage: "75%",
          value: "75"
        },
        {
          id: "typescript",
          content: "Typescript",
          percentage: "70%",
          value: "70"
        },
        {
          id: "mysql",
          content: "MySQL",
          percentage: "75%",
          value: "75"
        },
        {
          id: "firebase",
          content: "Firebase",
          percentage: "80%",
          value: "80"
        },
        {
          id: "nodejs-express",
          content: "Node.js & Express",
          percentage: "70%",
          value: "70"
        },
        {
          id: "graphql",
          content: "GraphQL",
          percentage: "70%",
          value: "70"
        },
        {
          id: "phyton",
          content: "Phyton",
          percentage: "70%",
          value: "70"
        }
      ],
      about_me: [
        {
          id: "first-p-about",
          content: "Hi, my name is Komang Nova Artawan. I am from Bali, Indonesia. I've graduated from Udayana University as Bachelor Degree in Computer Science Department, and my 'Expected' speciality after graduated from that is to work as Software Engineer, or Data Scientist."
        },
        {
          id: "second-p-about",
          content: "Currently, i'm working as Junior Programmer for known University in Bali named Undiknas University, my main job there was to develop mobile and web apps for helping study process of the students. By work there, i used to know some Front End Framework such as Ionic, Flutter, Angular, and GraphQL and Firebase for Back End. Now, i am also excited to learn React JS and React Native"
        },
        {
          id: "third-p-about",
          content: "To fill my spare time, I've create some Mobile Apps and Web Apps with Flutter, such as Children's Arithmetic Game, Football Info Apps, and Barcode Scanner Apps for maintaining stall product, and Questionnaire Web & Admin Panel. I also take part time project in another University to develop Web Apps using Codeigniter to maintaining Financial System and Academic System."
        }
      ]
    };
  }

  render() {
    return (
      <section id="about" className="about-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="box-shadow-full">
                <div className="row">
                  <div className="col-md-6">
                    <div className="row">
                      <div
                        className="col-sm-6 col-md-5"
                        style={{ margin: "0 auto" }}
                      >
                        <div
                          className="about-img"
                          style={{ textAlign: "center" }}
                        >
                          <img
                            className="img-fluid rounded b-shadow-a"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div className="skill-mf">
                      {this.state.skills.map(skill => {
                        return (
                          <React.Fragment key={skill.id}>
                            <span>{skill.content}</span>{" "}
                            <span className="pull-right">
                              {skill.percentage}
                            </span>
                            <div className="progress">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: skill.percentage }}
                                aria-valuenow={skill.value}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-2">
                        <h5 className="title-left">About Me</h5>
                      </div>
                      {this.state.about_me.map(content => {
                        return (
                          <p className="lead" key={content.id}>
                            {content.content}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
